export const SIDEBAR_WIDTH = '228px';
export const SIZE_UNIT = '48px';
export const SIZE_2XUNIT = '96px';
export const PADDING = '8px';
export const PADDING4 = '4px';
export const PADDING32 = '32px';
export const AGENDA_WIDTH = '320px';
